import CryptoJS from 'crypto-js';

type JsonValue = string | number | boolean | null | JsonValue[] | { [key: string]: JsonValue };

const DEFAULT_SECRET = 'ciclii-insecure-secret';

const getSecret = () => {
    const secret = process.env.REACT_APP_API_SECRET?.trim();
    return secret && secret.length > 0 ? secret : DEFAULT_SECRET;
};

export const encryptPayload = (payload: unknown): string => {
    try {
        const normalized: JsonValue = payload === undefined ? null : (payload as JsonValue);
        const serialized = JSON.stringify(normalized);
        return CryptoJS.AES.encrypt(serialized, getSecret()).toString();
    } catch (error) {
        console.error('Encryption error:', error);
        throw error;
    }
};

export const decryptPayload = <T = unknown>(cipherText: string): T => {
    try {
        const bytes = CryptoJS.AES.decrypt(cipherText, getSecret());
        const decrypted = bytes.toString(CryptoJS.enc.Utf8);
        return decrypted ? (JSON.parse(decrypted) as T) : ({} as T);
    } catch (error) {
        console.error('Decryption error:', error);
        throw error;
    }
};
